import { render } from "./CustomButtom.vue?vue&type=template&id=d22c1b9c&scoped=true"
import script from "./CustomButtom.vue?vue&type=script&lang=js"
export * from "./CustomButtom.vue?vue&type=script&lang=js"

import "./CustomButtom.vue?vue&type=style&index=0&id=d22c1b9c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22c1b9c"]])

export default __exports__